/**
 * Render Okendo-style reviews from LD_REVIEWS when live widget is empty.
 */
(function () {
  function stars(n) {
    var full = Math.round(Number(n) || 0);
    return "★★★★★".slice(0, full) + "☆☆☆☆☆".slice(0, Math.max(0, 5 - full));
  }
  function fmt(n) {
    return Number(n).toLocaleString("en-US");
  }
  function render(root, data) {
    if (!root || !data) return;
    var avg = data.averageRating;
    var count = data.reviewCount;
    var bd = data.breakdown || {};
    var rec = data.recommendPercent || 0;
    var list = data.reviews || [];

    var maxBar = Math.max(1, bd["5"] || 0, bd["4"] || 0, bd["3"] || 0, bd["2"] || 0, bd["1"] || 0);
    var bars = [5, 4, 3, 2, 1]
      .map(function (k) {
        var v = bd[String(k)] || 0;
        var pct = Math.round((v / maxBar) * 100);
        return (
          '<div class="ld-rev__bar-row"><span>' +
          k +
          "</span><div class=\"ld-rev__bar\"><i style=\"width:" +
          pct +
          '%"></i></div><span>' +
          fmt(v) +
          "</span></div>"
        );
      })
      .join("");

    var cards = list
      .map(function (r) {
        return (
          '<article class="ld-rev__card">' +
          '<div class="ld-rev__card-top"><strong>' +
          (r.name || "Customer") +
          "</strong>" +
          (r.verified ? '<span class="ld-rev__verified">Verified Buyer</span>' : "") +
          "</div>" +
          '<div class="ld-rev__stars" aria-label="Rated ' +
          r.rating +
          ' out of 5">' +
          stars(r.rating) +
          "</div>" +
          (r.title ? "<h4>" + r.title + "</h4>" : "") +
          "<p>" +
          (r.body || "") +
          "</p>" +
          '<div class="ld-rev__meta">' +
          (r.productName ? "Reviewing " + r.productName + " · " : "") +
          (r.date || "") +
          "</div></article>"
        );
      })
      .join("");

    root.innerHTML =
      '<div class="ld-rev__header">' +
      '<div class="ld-rev__avg"><div class="ld-rev__avg-num">' +
      avg +
      '</div><div class="ld-rev__stars">' +
      stars(avg) +
      "</div><div>Based on " +
      fmt(count) +
      " reviews</div></div>" +
      '<div class="ld-rev__breakdown">' +
      bars +
      "</div>" +
      '<div class="ld-rev__rec"><strong>' +
      rec +
      "%</strong> would recommend these products</div></div>" +
      '<div class="ld-rev__list">' +
      cards +
      "</div>";
  }

  function init() {
    var root = document.getElementById("ld-reviews-fallback");
    if (!root || !window.LD_REVIEWS) return;
    var handle = root.getAttribute("data-handle");
    if (handle && handle.indexOf("drlivingood-1") === 0) handle = "drlivingood-1";
    if (handle && handle.indexOf("drlivingood-2") === 0) handle = "drlivingood-2";
    var data = (window.LD_REVIEWS.products || {})[handle];
    if (!data) return;

    // Prefer live Okendo widget if it painted reviews
    var live = document.querySelector("#ld-oke-widget .oke-w, #ld-oke-widget .okeReviews");
    var hasLive = live && live.innerText && live.innerText.replace(/\s+/g, "").length > 40;
    if (hasLive) {
      root.hidden = true;
      return;
    }
    render(root, data);
    root.hidden = false;
  }

  // Update star badge numbers from data
  function badge() {
    var el = document.getElementById("ld-star-badge");
    if (!el || !window.LD_REVIEWS) return;
    var handle = el.getAttribute("data-handle");
    if (handle && handle.indexOf("drlivingood-1") === 0) handle = "drlivingood-1";
    if (handle && handle.indexOf("drlivingood-2") === 0) handle = "drlivingood-2";
    var data = (window.LD_REVIEWS.products || {})[handle];
    if (!data) return;
    el.innerHTML =
      '<span class="ld-star-badge__score">' +
      data.averageRating +
      "</span>" +
      '<span class="ld-star-badge__stars" aria-hidden="true">★★★★★</span>' +
      '<span class="ld-star-badge__count">(' +
      Number(data.reviewCount).toLocaleString("en-US") +
      ")</span>";
  }

  document.addEventListener("DOMContentLoaded", function () {
    badge();
    init();
    // Re-check after Okendo has time to load
    setTimeout(init, 2500);
    setTimeout(init, 6000);
  });
})();
